import {
  useCreateShareLinkMutation,
  useLazyGetShareLinkQuery,
  useRevokeShareLinkMutation,
} from "@/services/(my-space)/api.ai-assistant";
import { AiShareTrigger } from "@/components/ai-assistant/ai-share-trigger";

interface Props {
  sessionId: string;
  conversationTitle?: string;
  variant?: "icon" | "button";
  /** Restyle the trigger (e.g. to match a toolbar's ghost icons). */
  triggerClassName?: string;
}

export const MyspaceShareTrigger = (props: Props) => {
  const [fetchShareLink, { isFetching }] = useLazyGetShareLinkQuery();
  const [createShareLink, { isLoading: isCreating }] =
    useCreateShareLinkMutation();
  const [revokeShareLink, { isLoading: isRevoking }] =
    useRevokeShareLinkMutation();

  return (
    <AiShareTrigger
      {...props}
      isFetching={isFetching}
      isCreating={isCreating}
      isRevoking={isRevoking}
      fetchShareLink={fetchShareLink}
      createShareLink={createShareLink}
      revokeShareLink={revokeShareLink}
    />
  );
};
